<template>
<div class="chapter">
<div class="inner_page">
<a id="pagev">
<p class="dedicat"><em class="italic bold">‘For my mother, Barbara’</em></p>
</a><a id="pagevi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?7db95e23